import React from "react";
import Modal from 'react-awesome-modal';
import { observer } from "mobx-react";
import store from '../Stores/SurveyStore'

const PrintModal = observer(() => {
    const closePrintModal = () => {
        store.showPrintModal = false;
    }

    const printCurrentPage = () => {
        window.print();
        closePrintModal();
    }

    const printAllPages = () => {

    }

    return (
        <React.Fragment>
            <section>
                <Modal
                    visible={store.showPrintModal}
                    width="600"
                    height="200"
                    effect="fadeInDown"
                    onClickAway={closePrintModal}
                >
                    <div className="helpModal">
                        <h3> <i className="fa fa-print"></i> Print
                                <span onClick={closePrintModal} className="close-button topright">&times;</span>
                        </h3>

                        <hr />
                        <div className="center-div">
                            <a onClick={printCurrentPage} className="btn btn-info2" role="button">Print Current Page</a>
                            <a disabled onClick={printAllPages} className="btn btn-info2" role="button">Print Entire Survey</a><br />
                        </div>

                    </div>
                </Modal>
            </section>

        </React.Fragment>
    );

});

export default PrintModal;